import {ButtonHTMLAttributes, ReactElement, ReactNode} from "react";
import {omit} from "ramda";

export interface IconButtonProps {
    children: ReactNode
}

export function IconButton(props: IconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement {
    const restAttributes = omit(["children", "className"], props);
    return (
        <button className="bg-white rounded-full border border-secondary
                           px-2 py-2 text-secondary w-11 h-11 flex justify-center items-center"
                {...restAttributes}>
            {props.children}
        </button>
    );
}